import { format as formatDate } from 'date-fns';
import { __ } from '../../utilities';
import config from '../../config';

export const MY_SPORTNET_INVITATION_URL =
  'https://my.sportnet.online/invitations';

export const isExpired = invitation =>
  !!(
    invitation.expiration &&
    !invitation.status &&
    new Date(invitation.expiration) < new Date()
  );

export const getInvitationState = invitation => {
  if (invitation.status === 'accepted') {
    return { label: __('Akceptovaná'), color: '#28a745' };
  }
  if (invitation.status === 'rejected') {
    return { label: __('Odmietnutá'), color: '#dc3545' };
  }
  if (invitation.pending && invitation.pending.status) {
    return { label: __('Spracováva sa'), color: '#ffc107' };
  }
  if (isExpired(invitation)) {
    return { label: __('Expirovaná'), color: '#6c757d' };
  }
  return { label: __('Čaká na vybavenie'), color: '#17a2b8' };
};

export const formatDateTime = value =>
  value ? formatDate(new Date(value), config.DATE_FORMAT_WITH_TIME) : '-';
